module.exports = __webpack_public_path__ + "static/media/traces_new.8140d00f.png";